import { isValid } from "date-fns";

export const setDisplayedParkingPeriod = (
    selectedStartDate: Date,
    selectedEndDate: Date,
    selectedStartTime: Date | undefined,
    selectedEndTime: Date | undefined
) =>
{
    let startDate = "Érvénytelen";
    let endDate = "Érvénytelen";
    let startTime = "Érvénytelen";
    let endTime = "Érvénytelen";

    if (isValid(selectedStartDate))
    {
        startDate = selectedStartDate.toISOString().slice(0, 10).replaceAll("-", ".");
    }
    if (isValid(selectedEndDate))
    {
        endDate = selectedEndDate.toISOString().slice(0, 10).replaceAll("-", ".");
    }

    if (selectedStartTime && selectedEndTime)
    {
        if (isValid(selectedStartTime))
        {
            startTime = selectedStartTime.getHours().toString().padStart(2, "0")
            + ":" + selectedStartTime.getMinutes().toString().padStart(2, "0");
        }
        if (isValid(selectedEndTime))
        {
            endTime = selectedEndTime.getHours().toString().padStart(2, "0") + ":" + selectedEndTime.getMinutes().toString().padStart(2, "0");

        }
        return (startDate + " " + startTime + " - " + endDate + " " + endTime);
    }
    else if (selectedStartTime)
    {
        if (isValid(selectedStartTime))
        {
            startTime = selectedStartTime.getHours().toString().padStart(2, "0")
            + ":" + selectedStartTime.getMinutes().toString().padStart(2, "0");
        }
        return (startDate + " " + startTime + " - " + endDate);
    }
    else if (selectedEndTime)
    {
        if (isValid(selectedEndTime))
        {
            endTime = selectedEndTime.getHours().toString().padStart(2, "0") + ":" + selectedEndTime.getMinutes().toString().padStart(2, "0");
        }
        return (startDate + " - " + endDate + " " + endTime);
    }
    else
    {
        return (startDate + " - " + endDate);
    }
};
